import React from 'react';

// Los birux y los dias se repiten al crear varios comandos seguidos; el nombre
// del comando no. Guardamos solo esos dos en sessionStorage para que salir de la
// pestaña (adminPanel desmonta el componente) no los devuelva a los defaults.
const PREFS_KEY = 'codeRewardPrefs';
const DEFAULT_POINTS = 100;
const DEFAULT_LIFETIME = 30;

function readPrefs() {
  try {
    const raw = sessionStorage.getItem(PREFS_KEY);
    if (!raw) return null;
    const prefs = JSON.parse(raw);
    if (!prefs || typeof prefs !== 'object') return null;
    return prefs;
  } catch {
    return null;
  }
}

function writePrefs(prefs) {
  try {
    sessionStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch { }
}

// Los inputs guardan el string crudo del onChange, asi que un campo vacio o a
// medio escribir no debe reaparecer como caja vacia al volver a la pestaña.
function sanitize(value, def, min, max) {
  const num = parseInt(value, 10);
  if (isNaN(num) || num < min || num > max) return def;
  return num;
}

const AdminCodeReward = () => {
  const [code, setCode] = React.useState('');
  const [points, setPoints] = React.useState(() => {
    const prefs = readPrefs();
    return sanitize(prefs && prefs.points, DEFAULT_POINTS, 1, 100000);
  });
  const [lifeTime, setLifeTime] = React.useState(() => {
    const prefs = readPrefs();
    return sanitize(prefs && prefs.lifeTime, DEFAULT_LIFETIME, 0, 3650);
  });
  const [status, setStatus] = React.useState('');
  const [statusType, setStatusType] = React.useState(''); // 'success' | 'error' | ''
  const [loading, setLoading] = React.useState(false);

  // Persistimos mientras se edita, no solo al crear: asi tampoco se pierde un
  // valor ya tecleado pero aun sin enviar.
  React.useEffect(() => {
    writePrefs({ points, lifeTime });
  }, [points, lifeTime]);

  const errorMessages = {
    invalid_code: 'Comando inválido (sin espacios, máximo 50 caracteres)',
    invalid_points: 'Cantidad de birux comodín inválida (entero entre 1 y 100000)',
    invalid_lifetime: 'Días de caducidad inválidos (entero entre 0 y 3650)',
    code_exists: 'Ese comando ya existe y sigue vigente. Espera a que caduque o usa otro nombre.',
    admin_required: 'Sesión de admin caducada, vuelve a iniciar sesión',
    server_error: 'Error del servidor'
  };

  const handleCreate = async () => {
    // El "!" lo escribe el usuario en el chat, aqui se guarda sin prefijo.
    const cleanCode = code.trim().replace(/^!+/, '').trim();
    if (!cleanCode || /\s/.test(cleanCode) || cleanCode.length > 50) {
      setStatus(errorMessages.invalid_code);
      setStatusType('error');
      return;
    }
    const pointsNum = parseInt(points, 10);
    if (isNaN(pointsNum) || pointsNum < 1 || pointsNum > 100000) {
      setStatus(errorMessages.invalid_points);
      setStatusType('error');
      return;
    }
    const lifeTimeNum = parseInt(lifeTime, 10);
    if (isNaN(lifeTimeNum) || lifeTimeNum < 0 || lifeTimeNum > 3650) {
      setStatus(errorMessages.invalid_lifetime);
      setStatusType('error');
      return;
    }

    setLoading(true);
    setStatus('');
    setStatusType('');
    try {
      const formData = new FormData();
      formData.append('code', cleanCode);
      formData.append('points', pointsNum);
      formData.append('lifeTime', lifeTimeNum);
      const res = await fetch('/api/adminLogin?action=createRewardCode', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data && data.success) {
        const canal = [];
        if (data.announced && data.announced.twitch) { canal.push('Twitch'); }
        if (data.announced && data.announced.youtube) { canal.push('YouTube'); }
        const aviso = canal.length > 0
          ? 'Anunciado en ' + canal.join(' y ') + '.'
          : 'No hay directo activo, no se ha anunciado en el chat.';
        setStatus(
          (data.revived ? 'Comando !' + data.code + ' resucitado' : 'Comando !' + data.code + ' creado') +
          ' (' + data.points + ' birux comodín, ' +
          (data.lifeTime > 0 ? data.lifeTime + ' días' : 'sin caducidad') + '). ' + aviso
        );
        setStatusType('success');
        setCode('');
      } else {
        const key = data && data.error;
        setStatus(errorMessages[key] || ('Error: ' + (key || 'desconocido')));
        setStatusType('error');
      }
    } catch (err) {
      setStatus('Error al crear el comando recompensa');
      setStatusType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='heroes formOver'>
      <h1>Comando Recompensa</h1>
      <div className='formFieldRow'>
        <label className='formFieldLabel heroes'>Comando</label>
        <input
          className='userSearch'
          placeholder='GEL (sin el !, respeta mayúsculas)'
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { handleCreate(); } }}
        />
      </div>
      <div className='formFieldRow'>
        <label className='formFieldLabel heroes'>Birux comodín</label>
        <input
          className='userSearch'
          type='number'
          min='1'
          max='100000'
          step='1'
          value={points}
          onChange={(e) => setPoints(e.target.value)}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </div>
      <div className='formFieldRow'>
        <label className='formFieldLabel heroes'>Días de caducidad</label>
        <input
          className='userSearch'
          type='number'
          min='0'
          max='3650'
          step='1'
          value={lifeTime}
          onChange={(e) => setLifeTime(e.target.value)}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </div>
      <p style={{ fontSize: 13, color: '#ccc' }}>
        0 días = no caduca nunca. El chat solo recibe el aviso si estás en directo; la alerta del overlay sale siempre.
      </p>
      <div className='navTops heroes unselectable'>
        <div onClick={() => { if (!loading) { handleCreate(); } }}>Crear comando</div>
      </div>
      {loading ? <p>Cargando...</p> : null}
      {status ? (
        <p
          role={statusType === 'error' ? 'alert' : 'status'}
          style={{
            padding: '8px 12px',
            borderRadius: 4,
            fontWeight: 600,
            color: statusType === 'success' ? '#0a6b0a' : statusType === 'error' ? '#8a1a1a' : 'inherit',
            backgroundColor: statusType === 'success' ? '#d9f5d9' : statusType === 'error' ? '#fdecea' : 'transparent'
          }}
        >
          {status}
        </p>
      ) : null}
    </div>
  );
};

export default AdminCodeReward;
